/**
 * FBSBancaSUMAK
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ComisionTransferenciaExternaMLS } from './comisionTransferenciaExternaMLS';
import { ConceptoTransferenciaExternaMLS } from './conceptoTransferenciaExternaMLS';
import { TipoCuentaTransferenciaExternaMLS } from './tipoCuentaTransferenciaExternaMLS';
import { TipoIdentificacionTransferenciaExternaMLS } from './tipoIdentificacionTransferenciaExternaMLS';
import { TipoInstitucionTransferenciaExternaMLS } from './tipoInstitucionTransferenciaExternaMLS';

export interface ObtenerConsolidadoTransferenciaExternaMS { 
    comisiones?: Array<ComisionTransferenciaExternaMLS>;
    conceptos?: Array<ConceptoTransferenciaExternaMLS>;
    tiposCuenta?: Array<TipoCuentaTransferenciaExternaMLS>;
    tiposInstitucion?: Array<TipoInstitucionTransferenciaExternaMLS>;
    tiposIdentificacion?: Array<TipoIdentificacionTransferenciaExternaMLS>;
}